// In your slices/Content/UpdateCategorySlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  response: null,
  error: null
};

const updateCategorySlice = createSlice({
  name: 'updateCategory',
  initialState,
  reducers: {
    updateCategoryRequest: (state) => {
      state.loading = true;
      state.response = null;
      state.error = null;
    },
    updateCategorySuccess: (state, action) => {
      state.loading = false;
      state.response = action.payload;
      state.error = null;
    },
    updateCategoryFailure: (state, action) => {
      state.loading = false;
      state.response = null;
      state.error = action.payload;
    },
    updateCategoryStateReset: (state) => {
      state.loading = false;
      state.response = null;
      state.error = null;
    }
  }
});

export const {
  updateCategoryRequest,
  updateCategorySuccess,
  updateCategoryFailure,
  updateCategoryStateReset
} = updateCategorySlice.actions;

export default updateCategorySlice.reducer;